import React, { Component } from 'react';
import MasterString from '../Entities/LocaleString.js';

function MasterStringsService (apiInstance)
{
  const api = apiInstance;

  this.bulk = (strings) => {
    let data = [];
    const that = this;

    strings.forEach(function (string) {
      if (string.props.isDirty) {
        data.push({ key: string.props.key, action: 'update', context: string.props.context, description: string.props.description });
      }
    });

    if (!data.length) {
      return false;
    }

    return api.request('PATCH', data, '/strings', {});
  }

  this.retrieve = () => {
  	return api.request('GET', null, '/strings', {})
      .then(function (response) {
        const data = response.data.data;
        return data.strings.map(function (data) {
          return new MasterString(data);
        });
      })
      .catch(function (error) {
        throw error;
      });
  } 

  this.apply = (strings, exceptions) => {
    let data = {};

    Object.keys(strings).forEach(function (string) {
      let tmp = {};
      tmp[string] = strings[string].new;
      data = Object.assign(data, tmp);
    });

    return api.request('POST', { strings: data, invalidate_except: exceptions }, '/strings', {});
  }

  this.compare = (file) => {
    const formData = new FormData();
    formData.append('master', file);

    return api.request('POST', formData, '/strings/compare', { 'Content-Type': 'multipart/form-data' });
  }

  return this;
}

export default MasterStringsService;


// WEBPACK FOOTER //
// ./src/Services/MasterStringsService.js